"use client";

import ListPage from "@/components/ui/ListPage";
import PostCard from "@/components/blog/PostCard";
import { useSearchParams } from "next/navigation";
import { useMemo } from "react";

export default function ArticlesClientPage({
    initialArticles = [],
    initialQ = "",
    initialMeta = {},
    initialCategory = "",
    initialTags = [],
}) {
    // Keep these for rendering the current filters in the UI, but do NOT fetch here.
    const searchParams = useSearchParams();
    const filters = useMemo(() => {
        const q = searchParams?.get("q") || initialQ;
        const category = searchParams?.get("category") || initialCategory;
        const tagsParam = searchParams?.get("tags") || initialTags.join(",");
        const tags = tagsParam.split(",").filter(Boolean);
        return { q, category, tags };
    }, [searchParams, initialQ, initialCategory, initialTags]);

    return (
        <ListPage
            // ⛔️ remove fetchData — no client fetch
            Card={PostCard}
            title="All Articles"
            placeholder="Search articles…"
            initialData={initialArticles}
            initialMeta={initialMeta}
            initialQ={filters.q}
            cardPropName="post"
            // ListPage will update the URL; the server page will re-render and pass new props
        />
    );
}
